(function(factory){
    if(typeof module!=="undefined" && module.exports) {
        module.exports=factory;
    } else {
        factory(jQuery,window,document);
    }
}(function($) {
    $.id_radiocheckbox = function(el, options) {
        var _this = this;
        this.$element = $(el);
        this.$fakeElement = null;
        this.$elementWrapper = null;
        this.$label = null;
        this.callback = null;
        this.value = null;

		/**
		 *
		 */
		this.init = function(){
            this.options = $.extend({}, $.id_radiocheckbox.defaultOptions, options);
			if (typeof this.options.callback == 'function') {
				this.callback = this.options.callback;
			}
            this.$fakeElement = $('<div class=" ' + this.options.fakeElement + ' "></div>').insertAfter(this.$element);
            this.$elementWrapper = this.$element.parent();
            this.$label = this.$elementWrapper.find('label');
			this.value = this.$element.val();
            // check if radio is disabled before adding event listener to fake radio and label
            if (!this.$element.attr('disabled')) {
                this.$fakeElement.add(this.$label).off('click').on('click', function (e) {
                    e.preventDefault();
                    _this.toggleRadio();
                });
            } else {
                this.$fakeElement.addClass('disabled');
            }
            if (this.$element.attr('checked')){
            	this.$fakeElement.toggleClass('active');
				if ( this.callback ) {
					this.callback.call(this);
				}
			}
        };
      this.uncheck = function() {
        this.$element.prop('checked', false);
        this.$element.trigger('change');
        this.$fakeElement.removeClass('active');
      };
      this.check = function() {
        this.$element.prop('checked', true);
        this.$element.trigger('change');
        this.$fakeElement.addClass('active');
      };

		/**
		 *
		 */
		this.toggleRadio = function () {
          this.$element.trigger('click');
            this.$element.attr('checked') === 'checked' ? this.$element.removeAttr('checked') : this.$element.attr('checked', '');
            if (!this.options.multiple) {
				// if this is a radio, reset group's other radios
				this.$elementWrapper
					.siblings()
					.find('.' + this.options.fakeElement)
					.removeClass('active')
					.end()
					.find('.id-radio')
					.removeAttr('checked');
			}

            this.$fakeElement.toggleClass('active');
			if ( this.callback ) {
				this.callback.call(this);
			}
        };
        this.init();
    };

    $.id_radiocheckbox.defaultOptions = {
    	// set to true for a checkbox
    	'multiple': false,
		'fakeElement': 'id-fake-radio'
    };

    $.fn.id_radiocheckbox = function(options) {
      return this.each(function() {
        var instance = new $.id_radiocheckbox(this, options);
        $(this).data('id_radiocheckbox', instance);
      });
    };
}));
